import React, {useEffect, useState} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import BackButton from "../common/BackButton";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";

const apiUrl = Config.apiUrl;

const CashRegisterReport = () => {
    const navigate = useNavigate();
    const [, setLoading] = useRecoilState(loadingAtom);
    const searchParams = new URLSearchParams(window.location.search);
    const id = searchParams.get('id');
    const [report, setReport] = useState(null);

    async function makeQuery() {
        if (!id) {
            navigate('/cashregisterlist');
            return;
        }
        try {
            setLoading(true);
            const url = apiUrl + '/api/cash-registers/' + id + '/report';
            const response = await makeRequest(url, 'GET', {'Useruuid': Cookies.get('userUUID')});
            setReport(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        makeQuery();
    }, [id]);

    if (!report) {
        return null;
    }

    const formatCurrency = (value) => (value ?? 0).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const formatDateTime = (value) => new Date(value).toLocaleString('pt-BR');
    const MOVEMENT_TYPE_SANGRIA = 1;

    return (
        <div>
            <div className="header-label">Relatório de Fechamento de Caixa</div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Aberto em:</div>
                <div>{new Date(report.cashRegister.openedAt).toLocaleString('pt-BR')}</div>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Aberto por:</div>
                <div>{report.cashRegister.openedByUser?.name}</div>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Valor de abertura:</div>
                <div>R$ {formatCurrency(report.cashRegister.openingValue)}</div>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '180px'}}>Fechado em:</div>
                <div>{report.cashRegister.closedAt ? new Date(report.cashRegister.closedAt).toLocaleString('pt-BR') : 'Aberto'}</div>
            </div>

            <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Totais por Forma de Pagamento</div>

            <table style={{width: '400px'}}>
                <thead>
                <tr>
                    <th>Forma de Pagamento</th>
                    <th>Total</th>
                </tr>
                </thead>
                <tbody>
                {report.paymentMethodTotals.map((item, index) => (
                    <tr key={index}>
                        <td>{item.paymentMethodName}</td>
                        <td>
                            <div style={{textAlign: 'right'}}>R$ {formatCurrency(item.total)}</div>
                        </td>
                    </tr>
                ))}
                {report.paymentMethodTotals.length === 0 && (
                    <tfoot>
                    <tr>
                        <td colSpan={2}>Nenhum pagamento registrado neste caixa.</td>
                    </tr>
                    </tfoot>
                )}
                </tbody>
            </table>

            {report.movements && report.movements.length > 0 &&
                <>
                    <div className="header-label" style={{marginTop: '20px', fontSize: '18px'}}>Sangrias / Suprimentos</div>
                    <table style={{width: '100%'}}>
                        <thead>
                        <tr>
                            <th>Data/Hora</th>
                            <th>Tipo</th>
                            <th>Forma de Pagamento</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        {report.movements.map((movement, index) => (
                            <tr key={index}>
                                <td>{formatDateTime(movement.createdAt)}</td>
                                <td>{movement.type === MOVEMENT_TYPE_SANGRIA ? 'Sangria' : 'Suprimento'}</td>
                                <td>{movement.paymentMethod?.name}</td>
                                <td>{movement.description}</td>
                                <td>
                                    <div style={{textAlign: 'right'}}>R$ {formatCurrency(movement.value)}</div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </>
            }

            <div style={{marginTop: '10px', alignItems: 'center'}}>
                <div style={{width: '220px'}}>Total de Entradas (Suprimento):</div>
                <div>R$ {formatCurrency(report.totalEntradas)}</div>
            </div>
            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div style={{width: '220px'}}>Total de Saídas (Sangria):</div>
                <div>R$ {formatCurrency(report.totalSaidas)}</div>
            </div>

            <div style={{marginTop: '5px', alignItems: 'center'}}>
                <div className="total-label" style={{textAlign: 'right', fontSize: '30px', color: '#cc5545'}}>
                    Saldo do Caixa: R$ {formatCurrency(report.grandTotal)}
                </div>
            </div>

            <ActionButtonsManagerView>
                <BackButton onClick={() => navigate('/cashregisterlist')}/>
            </ActionButtonsManagerView>
        </div>
    );
};

export default CashRegisterReport;
